class PaypalBaseController {
    constructor(settings, paypalService, digitalPayPaymentInstrumentsService) {
        this.settings = settings;
        this.paypalService = paypalService;
        this.digitalPayPaymentInstrumentsService = digitalPayPaymentInstrumentsService;
    }

    $onInit() {
        this.isPaypalReady = false;
        this.hasPaymentError = false;
        this.unlinkMessage = this.settings.digitalPayMessages.paypalUnlinkMessage;
    }

    linkPaypal() {
        if (!this.isPaypalReady) {
            return;
        }
        this.paypalService.initAuthFlow();
    }

    setupPaypal() {
        return this.paypalService.setup({
            amount: this.getAmount(), // The child will set this if needed
            currency: 'AUD',
        }, (payload) => {
            this.isPaypalReady = false;
            this.paypalService.linkAccountWithDp(payload.nonce).then((response) => {
                if (response.Success) {
                    this.paypal = response.PayPal;
                    this.refreshLinked();
                    this.toggleSelected();
                } else {
                    this.onLinkFailed(response.ErrorCode, response.ErrorMessage);
                }
                this.isPaypalReady = true;
            });
        }, this.token).then((response) => {
            this.isPaypalReady = true;
            return response;
        });
    }

    unlinkPaypal(paymentInstrumentId = this.paypal.PaymentInstrumentId) {
        this.isPaypalReady = false;
        this.paypal = undefined;
        this.onUnlink();
        this.digitalPayPaymentInstrumentsService.deleteDigitalPayInstrument({ paymentInstrumentId }).then(((response) => {
            if (response.Success) {
                this.refreshLinked();
            } else {
                this.onUnlinkFailed(response.ErrorCode, response.ErrorMessage);
            }
        })).catch(() => {
            this.onUnlinkFailed();
        }).finally(() => {
            this.isPaypalReady = true;
        });
    }

    togglePayPal() {
        if (!this.paypal) {
            this.linkPaypal();
        } else {
            this.toggleSelected();
        }
    }

    /**
     * Override ride this.
     * @Overridable
     */
    refreshLinked() {
    }

    /**
     * Notifies when Paypal Unlink is successful.
     * @Overridable
     */
    onUnlink() {
    }

    /**
     * Notifies when Paypal Unlink fails.
     * @Overridable
     */
    onUnlinkFailed(errorCode = null, errorMessage = null) { // eslint-disable-line no-unused-vars
    }

    /**
     * Notifies when Paypal Link fails.
     * @Overridable
     */
    onLinkFailed(errorCode, errorMessage) { // eslint-disable-line no-unused-vars
    }

    /**
     * Toggle Paypal Select.
     * @Overridable
     */
    toggleSelected() {
    }

    // Override this if amount is needed
    getAmount() {
        return undefined;
    }
}

const paypalBaseComponentDefinition = {
    controller: PaypalBaseController,
    bindings: {
        paypal: '<',
        token: '<?',
    },
};

module.exports = {
    PaypalBaseController,
    paypalBaseComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/wallet/paypal/paypal-base.component.js